// const alertMessage = (prefix, message) => {
//   if (!message) return;
//   alert(prefix ? `${prefix}: ${message}` : message);
// };

// export const showSuccess = (message) => alertMessage("Success", message);

// export const showError = (message) =>
//   alertMessage("Error", message || "Something went wrong");

// export const showInfo = (message) => alertMessage("Info", message);

// export const showWarning = (message) => alertMessage("Warning", message);

// // Toast utility for showing notifications
class Toast {
  static success(message, duration = 3000) {
    this.showToast(message, "success", duration);
  }

  static error(message, duration = 4000) {
    this.showToast(message, "error", duration);
  }

  static warning(message, duration = 3000) {
    this.showToast(message, "warning", duration);
  }

  static info(message, duration = 3000) {
    this.showToast(message, "info", duration);
  }

  static showToast(message, type = "info", duration = 3000) {
    // Remove any existing toast
    this.removeExistingToast();

    // Create toast element
    const toast = document.createElement("div");
    toast.className = `custom-toast toast-${type}`;
    toast.innerHTML = `
      <div class="toast-content">
        <span class="toast-icon">${this.getIcon(type)}</span>
        <span class="toast-message">${message}</span>
        <button class="toast-close" onclick="this.parentElement.parentElement.remove()">×</button>
      </div>
    `;

    // Add to DOM
    document.body.appendChild(toast);

    // Show with animation
    setTimeout(() => {
      toast.classList.add("show");
    }, 10);

    // Auto remove after duration
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, duration);
  }

  static getIcon(type) {
    const icons = {
      success: "✓",
      error: "✕",
      warning: "⚠",
      info: "ℹ",
    };
    return icons[type] || "ℹ";
  }

  static removeExistingToast() {
    const existing = document.querySelector(".custom-toast");
    if (existing) {
      existing.remove();
    }
  }
}

export default Toast;
